import {
  get, post, put, del,
} from "services/api"
import { currentAccountId } from "services/authentication"
import { LanguageTemplate, Translations } from "sharedTypes"

const languageTemplatesBaseURL = (eventId: string) => `${import.meta.env.VITE_API_BASE}/api/v3/accounts/${currentAccountId()}/events/${eventId}/language_templates`

export const getLanguageTemplates = (eventId: string) => get<{ data: LanguageTemplate[] }>(`${languageTemplatesBaseURL(eventId)}.json`)

export const postLanguageTemplate = (
  eventId: string,
  languageTemplate: { name: string, translations: Translations },
) => post<LanguageTemplate>(`${languageTemplatesBaseURL(eventId)}.json`, { languageTemplate })

export const patchLanguageTemplate = (
  eventId: string,
  id: string,
  languageTemplate: Partial<{ name: string, translations: Translations }>,
) => put<LanguageTemplate>(`${languageTemplatesBaseURL(eventId)}/${id}.json`, { languageTemplate })

export const deleteLanguageTemplate = (eventId: string, id: string) => del<void>(`${languageTemplatesBaseURL(eventId)}/${id}.json`)

export const importLanguageTemplate = (
  eventId: string,
  sourceEventId: string,
  sourceLanguageTemplateId: string,
) => post<LanguageTemplate>(`${languageTemplatesBaseURL(eventId)}/import.json`, {
  sourceEventId,
  sourceLanguageTemplateId,
})
